var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        { staticClass: "modal-popup", on: { click: _vm.handleOverlayClick } },
        [
          _c(
            "div",
            {
              staticClass: "popup",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("h4", [_vm._v(_vm._s(_vm.title))]),
              _vm.message ? _c("p", [_vm._v(_vm._s(_vm.message))]) : _vm._e(),
              _vm._t("default"),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _vm._l(_vm.actions, function (action) {
                    return _c(
                      "div",
                      {
                        key: action.text,
                        class: ["button", `btn-${action.class || "primary"}`],
                        on: {
                          click: function ($event) {
                            return _vm.handleAction(action)
                          },
                        },
                      },
                      [_vm._v("\n        " + _vm._s(action.text) + "\n      ")]
                    )
                  }),
                  !_vm.actions || _vm.actions.length === 0
                    ? _c(
                        "div",
                        {
                          staticClass: "button btn-primary",
                          on: { click: _vm.handleClose },
                        },
                        [_vm._v("\n        OK\n      ")]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }